var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"skuTable",attrs:{"size":"mini","resizable":"","auto-resize":"","show-footer-overflow":"","columns":_vm.tableColumns,"loading":_vm.loading,"data":_vm.tableData,"max-height":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }